import { useIntl } from 'react-intl';
import { localize } from '@saviynt/common';

export type Localize = (
  key:
    | string
    | {
        id: string;
        defaultMessage: string;
      },
  placeholders?: object
) => string;

export const useLocalize = (): Localize => {
  const intl = useIntl();

  return (key, placeholders) => localize(intl, key, placeholders);
};

export type InvertedLocalize<M extends string> = (
  defaultMessage: M,
  placeholders?: object
) => string;

export const useInvertedLocalize = <M extends string>(
  invertedLookup: Record<M, string>
): InvertedLocalize<M> => {
  const intl = useIntl();

  return (defaultMessage: M, placeholders?: object): string => {
    const id = invertedLookup[defaultMessage];

    if (!id) {
      return defaultMessage;
    }

    return localize(intl, { id, defaultMessage }, placeholders);
  };
};
